import React, { useState } from "react";
import { ChevronDown, ChevronUp, Star, Phone } from "lucide-react";

const PricingSection = () => {
  const [openCategory, setOpenCategory] = useState(null);

  const toggleCategory = (index) => {
    setOpenCategory(openCategory === index ? null : index);
  };

  // Listen for custom events from ServicesSection
  React.useEffect(() => {
    const handleOpenCategory = (event) => {
      const { categoryIndex } = event.detail;
      setOpenCategory(categoryIndex);
    };

    window.addEventListener('openPricingCategory', handleOpenCategory);
    
    return () => {
      window.removeEventListener('openPricingCategory', handleOpenCategory);
    };
  }, []);

  const pricingCategories = [
    {
      title: "Tratamentos Faciais",
      icon: "✨",
      color: "bg-gold-warm",
      services: [
        { name: "Lux Caviar e Colágeno", price: "Sob consulta" },
        { name: "Peel Off Anti Manchas", price: "Sob consulta" },
        { name: "Catio Juvence", price: "Sob consulta" },
        { name: "Limpeza de Pele", price: "Sob consulta" },
        { name: "Peeling Ultrasónico", price: "Sob consulta" },
        { name: "Microdermabrasão", price: "Sob consulta" },
        { name: "Radiofrequência Rosto", price: "Sob consulta" }
      ]
    },
    {
      title: "Tratamentos Corporais",
      icon: "💆‍♀️",
      color: "bg-aqua-soft",
      services: [
        { name: "Purificação das Costas", price: "Sob consulta" },
        { name: "Esfoliação + Massagem 20min", price: "Sob consulta" },
        { name: "Pernas Cansadas", price: "Sob consulta" },
        { name: "Drenagem Linfática", price: "Sob consulta" },
        { name: "Shape (Endermologia + Soft Laser + RF + Vacuo)", price: "Sob consulta" },
        { name: "Lipo Laser", price: "Sob consulta" },
        { name: "Radiofrequência", price: "Sob consulta" },
        { name: "Pressoterapia", price: "Sob consulta" },
        { name: "Electroestimulação", price: "Sob consulta" }
      ]
    },
    {
      title: "Massagens & SPA",
      icon: "🌿",
      color: "bg-sage-soft",
      services: [
        { name: "Massagem Juvence", price: "Sob consulta" },
        { name: "Massagem Californiana (60min)", price: "Sob consulta" },
        { name: "Pack Juvence", price: "Sob consulta" },
        { name: "Algoterapia", price: "Sob consulta" },
        { name: "Geoterapia (Pedras Quentes)", price: "Sob consulta" },
        { name: "Vinoterapia", price: "Sob consulta" },
        { name: "Chocoterapia", price: "Sob consulta" },
        { name: "Candle Massage", price: "Sob consulta" },
        { name: "Bambus", price: "Sob consulta" },
        { name: "Massagem Sacro Craniana", price: "Sob consulta" },
        { name: "Relaxante", price: "Sob consulta" },
        { name: "Massagem Localizada (30min)", price: "Sob consulta" }
      ]
    },
    {
      title: "Cabeleireiro",
      icon: "✂️",
      color: "bg-cream-warm",
      services: [
        { name: "Madeixas Duas Cores", price: "Sob consulta" },
        { name: "Madeixas Prata + Matização", price: "Sob consulta" },
        { name: "Madeixas Touca + Matização", price: "Sob consulta" },
        { name: "Anti Frizz", price: "Sob consulta" },
        { name: "Alisamento", price: "Sob consulta" },
        { name: "Ondulação + Brushing", price: "Sob consulta" },
        { name: "Penteado Elaborado", price: "Sob consulta" },
        { name: "Coloração Orgânica", price: "Sob consulta" },
        { name: "Penteado Preso Dia", price: "Sob consulta" },
        { name: "Tratamento Nutrição", price: "Sob consulta" },
        { name: "Corte + Brushing", price: "Sob consulta" },
        { name: "Penteado Preso Simples", price: "Sob consulta" },
        { name: "Brushing", price: "Sob consulta" }
      ]
    },
    {
      title: "Depilação Laser Diodo Fibra Ótica",
      icon: "⚡",
      color: "bg-purple-500",
      services: [
        { name: "Buço", price: "Sob consulta" },
        { name: "Axilas", price: "Sob consulta" },
        { name: "Braços Completos", price: "Sob consulta" },
        { name: "Meia Perna", price: "Sob consulta" },
        { name: "Perna Completa", price: "Sob consulta" },
        { name: "Virilha", price: "Sob consulta" },
        { name: "Virilha Integral", price: "Sob consulta" },
        { name: "Costas", price: "Sob consulta" },
        { name: "Peito", price: "Sob consulta" },
        { name: "Pacotes Corporais", price: "Sob consulta" }
      ]
    },
    {
      title: "Estética & Maquilhagem",
      icon: "💄",
      color: "bg-gold-soft",
      services: [
        { name: "Jet Bronze", price: "Sob consulta" },
        { name: "Maquilhagem Noite", price: "Sob consulta" },
        { name: "Maquilhagem Flash", price: "Sob consulta" },
        { name: "Lifting Pestanas", price: "Sob consulta" },
        { name: "Pedicure + Verniz Gel", price: "Sob consulta" },
        { name: "Coloração Pestanas", price: "Sob consulta" },
        { name: "Pedicure Completa + Botas Térmicas", price: "Sob consulta" },
        { name: "Pedicure Completa", price: "Sob consulta" },
        { name: "Verniz Gel", price: "Sob consulta" },
        { name: "Tratamento Parafina", price: "Sob consulta" },
        { name: "Pedicure Express", price: "Sob consulta" },
        { name: "Manicure", price: "Sob consulta" }
      ]
    },
    {
      title: "Packs Noivas",
      icon: "💐",
      color: "bg-pink-400",
      services: [
        { name: "Pack Noiva Completo", price: "Sob consulta" },
        { name: "Prova de Maquilhagem", price: "Sob consulta" },
        { name: "Prova de Penteado", price: "Sob consulta" },
        { name: "Maquilhagem + Penteado Dia", price: "Sob consulta" },
        { name: "Tratamentos Faciais Pré-Casamento", price: "Sob consulta" },
        { name: "Manicure + Pedicure Noiva", price: "Sob consulta" },
        { name: "Pack Madrinhas", price: "Sob consulta" }
      ]
    },
    {
      title: "Espaço Cosmetologia",
      icon: "🧪",
      color: "bg-green-500",
      services: [
        { name: "Consultoria Produtos Orgânicos", price: "Sob consulta" },
        { name: "Produtos Faciais Biológicos", price: "Sob consulta" },
        { name: "Produtos Corporais Naturais", price: "Sob consulta" },
        { name: "Linhas Anti-Idade Orgânicas", price: "Sob consulta" },
        { name: "Produtos Pele Sensível", price: "Sob consulta" },
        { name: "Análise de Pele", price: "Sob consulta" },
        { name: "Protocolos Personalizados", price: "Sob consulta" }
      ]
    },
    {
      title: "Epilação",
      icon: "🪒",
      color: "bg-aqua-warm",
      services: [
        { name: "Pack: Pernas + Virilha Integral + Axilas", price: "Sob consulta" },
        { name: "Pack: Pernas + Virilha + Axilas", price: "Sob consulta" },
        { name: "Pack: Pernas + Virilha Integral", price: "Sob consulta" },
        { name: "Pack: Pernas + Virilha", price: "Sob consulta" },
        { name: "Pack: Meia Pernas + Axilas + Virilha", price: "Sob consulta" },
        { name: "Perna Inteira", price: "Sob consulta" },
        { name: "Virilha Decotada/Integral", price: "Sob consulta" },
        { name: "Meia Perna", price: "Sob consulta" },
        { name: "Braços", price: "Sob consulta" },
        { name: "Virilha", price: "Sob consulta" },
        { name: "Sobrancelhas", price: "Sob consulta" },
        { name: "Axilas", price: "Sob consulta" },
        { name: "Buço", price: "Sob consulta" },
        { name: "Linha Alba", price: "Sob consulta" },
        { name: "Queixo", price: "Sob consulta" },
        { name: "Patilhas", price: "Sob consulta" }
      ]
    }
  ];

  return (
    <section id="precos" className="py-20 bg-cream-light">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-playfair font-bold text-sage-dark mb-6">
            Preços & Pacotes
          </h2>
          <p className="text-xl text-sage-medium max-w-3xl mx-auto leading-relaxed">
            Descubra os nossos tratamentos personalizados. Entre em contacto connosco 
            para conhecer os preços e encontrar a melhor solução para si.
          </p>
        </div>

        <div className="space-y-6">
          {pricingCategories.map((category, index) => (
            <div key={index} className="bg-white rounded-2xl shadow-lg overflow-hidden">
              <button
                onClick={() => toggleCategory(index)}
                className="w-full p-6 flex items-center justify-between hover:bg-gray-50 transition-colors duration-200"
              >
                <div className="flex items-center space-x-4">
                  <div className={`w-12 h-12 ${category.color} rounded-full flex items-center justify-center text-white font-bold text-lg`}>
                    {category.icon}
                  </div>
                  <div className="text-left">
                    <h3 className="text-xl font-bold text-sage-dark">{category.title}</h3>
                    <p className="text-sage-medium text-sm">{category.services.length} serviços disponíveis</p>
                  </div>
                </div>
                <div className="text-sage-dark">
                  {openCategory === index ? <ChevronUp className="w-6 h-6" /> : <ChevronDown className="w-6 h-6" />}
                </div>
              </button>

              {openCategory === index && (
                <div className="px-6 pb-6 border-t border-gray-100">
                  <div className="grid md:grid-cols-2 gap-4 mt-4">
                    {category.services.map((service, serviceIndex) => (
                      <div key={serviceIndex} className="flex justify-between items-center py-2 border-b border-gray-100 last:border-b-0">
                        <span className="text-sage-dark">{service.name}</span>
                        <span className="font-semibold text-gold-warm">{service.price}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Contact for pricing */}
        <div className="mt-16 bg-gradient-to-br from-gold-warm to-gold-deep text-sage-dark rounded-3xl p-8 text-center">
          <Star className="w-12 h-12 mx-auto mb-4 text-sage-dark" />
          <h3 className="text-2xl font-playfair font-bold mb-4 text-sage-dark">Consulta Personalizada</h3>
          <p className="mb-6 max-w-2xl mx-auto text-sage-dark opacity-90">
            Cada cliente é único! Contacte-nos para uma consulta gratuita e personalizada. 
            Analisaremos as suas necessidades e apresentaremos a proposta ideal para si.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center max-w-md mx-auto">
            <a 
              href="tel:253279717"
              className="bg-white text-gold-warm px-6 py-3 rounded-full hover:bg-gray-100 transition-colors font-semibold flex items-center justify-center space-x-2"
            >
              <Phone className="w-5 h-5" />
              <span>Ligar Agora</span>
            </a>
          </div>
        </div>

        <div className="mt-12 text-center">
          <p className="text-sage-medium mb-6">
            Tem dúvidas sobre qual o melhor tratamento para si? A nossa equipa está aqui para ajudar.
          </p>
          <button 
            onClick={() => {
              const element = document.getElementById('contacto');
              if (element) element.scrollIntoView({ behavior: "smooth" });
            }}
            className="bg-sage-dark text-white px-8 py-4 rounded-full hover:bg-sage-medium transition-all duration-300 transform hover:scale-105 font-semibold"
          >
            Marcar Consulta Gratuita
          </button>
        </div>
      </div>
    </section>
  );
};

export default PricingSection;